import { type FC, memo } from 'react';
import { Modal, Button } from 'antd';
import { useIsMobile } from '../../hooks/use-media-query';

export interface StopAllSessionsModalProps {
  open: boolean;
  cameraNames: string[];
  onConfirm: () => void;
  onCancel: () => void;
}

export const StopAllSessionsModal: FC<StopAllSessionsModalProps> = memo(({
  open,
  cameraNames,
  onConfirm,
  onCancel,
}) => {
  const isMobile = useIsMobile();
  const cameraList = cameraNames.join(', ');

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={400}
      closable={false}
      maskClosable={true}
      styles={{
        body: {
          backgroundColor: '#FFFFFF',
        },
        content: {
          backgroundColor: '#FFFFFF',
          borderRadius: '8px',
        },
      }}
    >
      <div>
        {/* Title */}
        <h2 className="text-center text-[16px] font-bold text-gray-900 mb-4">Stop All Sessions?</h2>

        {/* Message */}
        <p className="text-center text-[12px] text-gray-700 mb-6">
          Would you like to stop all active counting sessions? The Sessions running on{' '}
          <strong>{cameraList}</strong> will be terminated.
        </p>

        {/* Buttons */}
        <div className={`flex justify-evenly`}>
          <Button
            onClick={onCancel}
            size="large"
            style={{
              flex: isMobile ? 'none' : 'none',
              width: isMobile ? '115px' : '128px',
              borderRadius: '24px',
              height: '32px',
              fontSize: '12px',
              fontWeight: '600',
              backgroundColor: '#E5E5EA',
              border: 'none',
              color: '#1C1C1E',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            size="large"
            style={{
              flex: isMobile ? 'none' : 'none',
              width: isMobile ? '115px' : '128px',
              borderRadius: '24px',
              height: '32px',
              fontSize: '12px',
              fontWeight: '600',
              backgroundColor: '#FF3B30',
              border: 'none',
              color: '#FFFFFF',
            }}
          >
            Stop All
          </Button>
        </div>
      </div>
    </Modal>
  );
});

StopAllSessionsModal.displayName = 'StopAllSessionsModal';
